import { pluginApi } from 'services/api';

export async function saveDistribution(response: any) {
  const { data } = await pluginApi.post(
    `points-distribution/approve-to-distribution`,
    response,
  );
  return data;
}
